module.exports = __webpack_public_path__ + "static/img/wisdomTopBanner.706b8d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wisdomTopBanner.png
// module id = QZc0
// module chunks = 2